import React, { useEffect } from 'react';
import './App.css';
import ResetNewPassword from './Components/Reset-New-Password/ResetNewPassword';
import ResetPassword from './Components/reset-password/ResetPassword';
import Dashboard from './Components/Dashboard/Dashboard';
import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import Login from './Components/Login-signup/Login';
import Procedures from './Components/Procedures/Procedures';
import Organization from './Components/Organization/Organization';
import User from './Views/Users/User';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { LoadProcedures } from './Redux/ProcedureReducer';
import Preview from './Views/Procedure/Preview';
import ProcedurePreview from './Views/Procedure/preview/index';
import FlowChart from './Views/Procedure/flowChart/index.jsx';

import { Toaster } from 'react-hot-toast';
import CreateProcedure from './Views/Procedure/CreateProcedure';
import EditProcedure from './Views/Procedure/EditProcedure';
import OrgLogin from './Views/organization/login/OrgLogin';
import Role from './Views/organization/roles/Role';
import ApiHandler from './ApiHandler';
import NewProcedure from './Views/Procedure/create';
import UpdateProcedure from './Views/Procedure/update';
import { getFromPersistance } from './Helpers/helper';
import { userLoginSuccess } from './Redux/OauthSlice';
import PrivacyPolicy from './Views/Privacy/index.jsx';
import DeleteAccount from './Components/DeleteAccount/DeleteAccount';
//Test
function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, isLogedIn, loggedOrg, isOrgAuth, procedures, folders } =
    useSelector(
      state => ({
        user: state.User.user,
        isLogedIn: state.User.isLogedIn,
        loggedOrg: state.Organization.loggedOrg,
        isOrgAuth: state.Organization.isOrgAuth,
        procedures: state.Procedure.procedures,
        folders: state.Folder.folders,
      }),
      shallowEqual
    );
  useEffect(() => {
    // console.log(user);
    if (user?.role?.includes('admin')) {
      const { password, ...userInfo } = user;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      ApiHandler.getOrgList();
      ApiHandler.getProcedureList();
      ApiHandler.getUsers(user._id);
    }
    ApiHandler.getFolders();
    if (user.role == 'user') {
      ApiHandler.getOrgByUser(user._id);
      // ApiHandler.getProcedureByUser(user._id);
      ApiHandler.getUsers(user._id);
    }
    if (isOrgAuth) {
      let pro = loggedOrg.procedures.map(_ => ({
        _id: _.procedure._id,
        name: _.procedure.name,
      }));
      dispatch(LoadProcedures(pro));
      ApiHandler.getUsers(loggedOrg._id);
    }
    // api.get("/org/org-list").then((res) => {
    //   if (res.status === 200) {
    //     dispatch(LoadOrganization(res.data.organizations));
    //   }
    // });
    ApiHandler.getRoles(user._id);
  }, [user, isLogedIn, isOrgAuth]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    
    // Skip redirection for reset password flow
    if (currentPath.startsWith('/reset-new-password')) {
      console.log('Reset password flow - skipping redirection');
      return;
    }

    const loggedInUser = JSON.parse(localStorage.getItem('auth'));
    if (loggedInUser) {
      dispatch(userLoginSuccess(loggedInUser));
      if (!currentPath.includes('/dashboard')) {
        localStorage.setItem('lastRoute', currentPath);
      }
      const isLogedIn = getFromPersistance();
      if (!loggedInUser.role.includes('admin') && isLogedIn && !currentPath.startsWith('/reset-new-password')) {
        navigate('/dashboard');
      }
    if (
      (currentPath.includes('/procedures/') &&
        currentPath.split('/').length >= 3) ||
      (currentPath.includes('/procedure-preview/') &&
        currentPath.split('/').length >= 3) ||
      currentPath.includes('/update-procedure')
    ) {
      if (procedures.length === 0 && folders.length === 0) {
        navigate('/procedures');
      }
    }
  }
}, []);

  return (
    <>
      <Toaster position={'top-right'} reverseOrder={false} />
      <Routes>
        {/* <Route exact path="/" element={<EnterPoint />} /> */}
        <Route exact path="/" element={<Login />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/org-login" element={<OrgLogin />} />
        <Route path="/reset-new-password" element={<ResetNewPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-new-password/:email" element={<ResetNewPassword />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route exact path="/privacy" element={<PrivacyPolicy />} />
        {/* <Route exact path="/previlledges" element={<Previllidges />} /> */}
        {/* <Route element={<AdminRoute/>}>
        </Route> */}
        <Route element={<UserRoute />}>
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/procedures" element={<Procedures />} />
          <Route exact path="/procedures/:id" element={<Procedures />} />
          <Route
            exact
            path="/create-procedure/:id"
            element={<CreateProcedure />}
          />

          <Route exact path="/new-procedure/:id" element={<NewProcedure />} />

          <Route exact path="/edit-procedure" element={<EditProcedure />} />

          <Route exact path="/update-procedure/:id" element={<UpdateProcedure />} />

          <Route
            exact
            path={'/procedure-previewedit/:id'}
            element={<Preview />}
          />

          <Route
            exact
            path={'/procedure-preview/:id'}
            element={<ProcedurePreview />}
          />

          <Route
            exact
            path={'/procedure-flowchart/:id'}
            element={<FlowChart />}
          />

          <Route exact path="/organization" element={<Organization />} />
          {/* <Route exact path="/user-dashboard" element={<UserDashboard />} /> */}
          <Route exact path="/user" element={<User />} />
          <Route exact path="/role-manage" element={<Role />} />
        </Route>
        {/* <Route element={<OrganizationRoute />}>
          <Route exact path="/org-dashboard" element={<OrgDashboard />} />
        </Route> */}
        <Route
          path="*"
          element={
            <Navigate to={getFromPersistance() ? '/dashboard' : '/login'} />
          }
        />
      </Routes>
    </>
  );
}
const UserRoute = () => {
  const isLogedIn = getFromPersistance();
  // const { user, isLogedIn } = useSelector((state) => state.User);
  return isLogedIn ? <Outlet /> : <Navigate to={'/login'} />;
};
const AdminRoute = () => {
  const { user, isLogedIn } = useSelector(state => state.User);
  return isLogedIn && user.role == 'admin' ? (
    <Outlet />
  ) : (
    <Navigate to={'/login'} />
  );
};
// const OrganizationRoute = () => {
//   const { isOrgAuth } = useSelector((state) => state.Organization);
//   return isOrgAuth ? <Outlet /> : <Navigate to="/org-login" />;
// };
export default App;
